import FavouritesModal from "./FavouritesModal";

export default FavouritesModal;